/* <newsletter-popup>: opens once after a delay; remembers dismissal/subscription in localStorage (try/catch for private mode). */
class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-popup-dialog]');
    if (!this.dialog) return;
    this.key = `kora:popup:${this.dataset.key || '1'}`;
    this.dialog.addEventListener('close', () => this.remember('dismissed'));
    this.dialog.addEventListener('submit', () => this.remember('subscribed'), true);

    /* After a successful signup Shopify reloads the page with ?customer_posted=true#PopupNewsletter */
    const justPosted = location.hash === '#PopupNewsletter' && this.querySelector('.form-message--success');
    if (justPosted) { this.remember('subscribed'); this.open(); return; }

    /* Theme editor: show the popup while the section is selected, never auto-open */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => { if (this.contains(e.target) || e.target.contains(this)) this.open(); });
      document.addEventListener('shopify:section:deselect', () => this.dialog.open && this.dialog.close());
      return;
    }
    if (!this.eligible()) return;
    const delay = (Number(this.dataset.delay) || 0) * 1000;
    this.timer = setTimeout(() => this.tryOpen(), delay);
  }
  disconnectedCallback() { clearTimeout(this.timer); }

  eligible() {
    const tpl = window.Kora && window.Kora.template;
    if (['cart', 'password', 'gift_card'].includes(tpl)) return false;
    if (this.dataset.pages === 'home' && tpl !== 'index') return false;
    if (/^\/(checkouts?|account)\b/.test(location.pathname)) return false;
    const state = this.read();
    if (state.subscribed) return false;
    if (state.dismissed) {
      const days = Number(this.dataset.days) || 7;
      if (Date.now() - state.dismissed < days * 864e5) return false;
    }
    return true;
  }
  tryOpen(attempt = 0) {
    /* don't interrupt another dialog (cart drawer, search, menu); retry a few times */
    if (document.querySelector('dialog[open]')) {
      if (attempt < 6) this.timer = setTimeout(() => this.tryOpen(attempt + 1), 5000);
      return;
    }
    this.open();
  }
  open() {
    if (window.Kora && window.Kora.openDialog) window.Kora.openDialog(this.dialog);
    else if (this.dialog.showModal) this.dialog.showModal();
  }
  read() { try { return JSON.parse(localStorage.getItem(this.key)) || {}; } catch (e) { return {}; } }
  remember(what) {
    const state = this.read();
    state[what] = what === 'subscribed' ? true : Date.now();
    try { localStorage.setItem(this.key, JSON.stringify(state)); } catch (e) { /* ignore */ }
  }
}
if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NewsletterPopup);
